import { forwardRef, memo } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconChannelWord = memo(
  forwardRef((props, ref) => {
    return (
      <SvgIcon
        {...props}
        ref={ref}
        viewBox="0 0 24 24"
      >
        <path
          d="M22.9997 1.7146H7.00029C6.73506 1.71483 6.48077 1.82029 6.29323 2.00783C6.10569 2.19537 6.00023 2.44966 6 2.71489V6.85746L15 8.25031L24 6.85746V2.71489C23.9998 2.44966 23.8943 2.19537 23.7068 2.00783C23.5192 1.82029 23.2649 1.71483 22.9997 1.7146Z"
          fill="#41A5EE"
        />
        <path
          d="M24 6.85693H6V11.9998L15 13.7141L24 11.9998V6.85693Z"
          fill="#2B7CD3"
        />
        <path
          d="M24 12H6V17.1429L15 18.8571L24 17.1429V12Z"
          fill="#185ABD"
        />
        <path
          d="M24 17.1431H6V21.2856C6.00023 21.5509 6.10569 21.8052 6.29323 21.9927C6.48077 22.1802 6.73506 22.2857 7.00029 22.2859H22.9997C23.2649 22.2857 23.5192 22.1802 23.7068 21.9927C23.8943 21.8052 23.9998 21.5509 24 21.2856V17.1431Z"
          fill="#103F91"
        />
        <path
          opacity="0.5"
          d="M12.8571 7.71408V17.8541C12.8553 18.1195 12.7491 18.3735 12.5614 18.5612C12.3737 18.7489 12.1197 18.8551 11.8543 18.8569H6V6.85693H12C12.2273 6.85693 12.4453 6.94724 12.6061 7.10799C12.7668 7.26873 12.8571 7.48675 12.8571 7.71408Z"
          fill="black"
        />
        <path
          d="M10.9997 6H1.00029C0.447843 6 0 6.44784 0 7.00029V16.9997C0 17.5522 0.447843 18 1.00029 18H10.9997C11.5522 18 12 17.5522 12 16.9997V7.00029C12 6.44784 11.5522 6 10.9997 6Z"
          fill="#185ABD"
        />
        <path
          d="M8.96266 15.75H7.61266L6.03809 10.5754L4.38809 15.75H3.03809L1.53809 8.25H2.88809L3.93809 13.5L5.51266 8.4H6.63809L8.13809 13.5L9.18809 8.25H10.4627L8.96266 15.75Z"
          fill="white"
        />
      </SvgIcon>
    );
  })
);
